import { render, staticRenderFns } from "./facturation_versionH.vue?vue&type=template&id=ce06f2dc&scoped=true&"
import script from "./facturation_versionH.vue?vue&type=script&lang=js&"
export * from "./facturation_versionH.vue?vue&type=script&lang=js&"
import style0 from "./facturation_versionH.vue?vue&type=style&index=0&id=ce06f2dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce06f2dc",
  null
  
)

export default component.exports